<div class="question-type__text">
  <h1 class="fs__xxl">Rank Sort</h1>
  <p class="fs__md">Participants can choose from a set of options and place them in a particular rank.</p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">Tell us your most and least favourite of the following sports:</p>
  <p class="fs__md">Options:</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Soccer</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Rugby</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Tennis</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Swimming</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Running</span>
    </li>
  </ul>
  <p class="fs__md">Ranks:</p>
  <ul class="question-type__bullet-points">
    <li class="fs__sm">
      <span class="text fw__500">Most Favourite</span>
    </li>
    <li class="fs__sm">
      <span class="text fw__500">Least Favourite</span>
    </li>
  </ul>
</div>
